import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { InsideSection } from '../components/sales/InsideSection';
import { PainSection } from '../components/sales/PainSection';
import { SolutionSection } from '../components/sales/SolutionSection';
import { VolumesSection } from '../components/sales/VolumesSection';
import { VisualSection } from '../components/sales/VisualSection';
import { BonusesSection } from '../components/sales/BonusesSection';
import { BeforeAfterSection } from '../components/sales/BeforeAfterSection';
import { AudienceSection } from '../components/sales/AudienceSection';
import { OfferSection } from '../components/sales/OfferSection';
import { OnePartSection } from '../components/sales/OnePartSection';
import { FaqSection } from '../components/sales/FaqSection';
import { FinalSection } from '../components/sales/FinalSection';
import { SiteFooter } from '../components/sales/SiteFooter';
export function SalesPage() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-brand-ivory font-body text-brand-charcoal" data-id="element-202" data-mp="3vp4k854585go">
      <header className="border-b border-brand-charcoal/10 bg-brand-paper" data-id="element-203" data-mp="35t02xb90jwaj">
        <div className="mx-auto flex max-w-6xl items-center justify-center px-5 py-3 lg:px-8" data-id="element-204" data-mp="35qx3k0lz0qt5">
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.22em] text-brand-charcoal" data-id="element-205" data-mp="30u6rdodaefd0">
            Hair Instructor Ready™
          </p>
        </div>
      </header>

      <main data-id="element-206" data-mp="3ti2kkj3ndp51">
        <HeroSection data-id="element-207" data-mp="3tghzdk383iju" />
        <InsideSection data-id="element-208" data-mp="3ojhs55un09r5" />
        <PainSection data-id="element-209" data-mp="3oj81dg1rpyke" />
        <SolutionSection data-id="element-210" data-mp="3oksur2ccjbgo" />
        <VolumesSection data-id="element-211" data-mp="3ohesrv7lh49r" />
        <VisualSection data-id="element-212" data-mp="3jk4v5sa1xmau" />
        <BonusesSection data-id="element-213" data-mp="3jjn1n3erxm6m" />
        <BeforeAfterSection data-id="element-214" data-mp="3jitqlq8s8aio" />
        <AudienceSection data-id="element-215" data-mp="3jm9ar7hbc9qy" />
        <OfferSection data-id="element-216" data-mp="3fjckculj79cg" />
        <OnePartSection data-id="element-217" data-mp="3fhrsxduik6it" />
        <FaqSection data-id="element-218" data-mp="3fijoioo42493" />
        <FinalSection data-id="element-219" data-mp="3fl5r09w59tkg" />
      </main>

      <SiteFooter data-id="element-220" data-mp="285huy2n6ey7l" />
    </div>;
}